export const $space4 = 4;
export const $space8 = 8;
export const $space16 = 16;
export const $space32 = 32;
export const $space64 = 64;